/* tslint:disable */
/* eslint-disable */
/**
 * GlassHouse.Dashboard.Api | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { DiscountScope } from './DiscountScope';
import {
    DiscountScopeFromJSON,
    DiscountScopeFromJSONTyped,
    DiscountScopeToJSON,
    DiscountScopeToJSONTyped,
} from './DiscountScope';
import type { DiscountCalculationType } from './DiscountCalculationType';
import {
    DiscountCalculationTypeFromJSON,
    DiscountCalculationTypeFromJSONTyped,
    DiscountCalculationTypeToJSON,
    DiscountCalculationTypeToJSONTyped,
} from './DiscountCalculationType';
import type { DiscountValueType } from './DiscountValueType';
import {
    DiscountValueTypeFromJSON,
    DiscountValueTypeFromJSONTyped,
    DiscountValueTypeToJSON,
    DiscountValueTypeToJSONTyped,
} from './DiscountValueType';
import type { ApiUserTasksGetPageParameter } from './ApiUserTasksGetPageParameter';
import {
    ApiUserTasksGetPageParameterFromJSON,
    ApiUserTasksGetPageParameterFromJSONTyped,
    ApiUserTasksGetPageParameterToJSON,
    ApiUserTasksGetPageParameterToJSONTyped,
} from './ApiUserTasksGetPageParameter';

/**
 * 
 * @export
 * @interface UpdateTuitionDiscountRequest
 */
export interface UpdateTuitionDiscountRequest {
    /**
     * 
     * @type {string}
     * @memberof UpdateTuitionDiscountRequest
     */
    discountId: string;
    /**
     * 
     * @type {DiscountCalculationType}
     * @memberof UpdateTuitionDiscountRequest
     */
    calculationType: DiscountCalculationType;
    /**
     * 
     * @type {DiscountValueType}
     * @memberof UpdateTuitionDiscountRequest
     */
    valueType: DiscountValueType;
    /**
     * 
     * @type {DiscountScope}
     * @memberof UpdateTuitionDiscountRequest
     */
    scope: DiscountScope;
    /**
     * 
     * @type {number}
     * @memberof UpdateTuitionDiscountRequest
     */
    value: number;
    /**
     * 
     * @type {ApiUserTasksGetPageParameter}
     * @memberof UpdateTuitionDiscountRequest
     */
    min: ApiUserTasksGetPageParameter;
    /**
     * 
     * @type {ApiUserTasksGetPageParameter}
     * @memberof UpdateTuitionDiscountRequest
     */
    max: ApiUserTasksGetPageParameter;
    /**
     * 
     * @type {string}
     * @memberof UpdateTuitionDiscountRequest
     */
    description: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateTuitionDiscountRequest
     */
    name: string | null;
    /**
     * 
     * @type {ApiUserTasksGetPageParameter}
     * @memberof UpdateTuitionDiscountRequest
     */
    priority: ApiUserTasksGetPageParameter;
}



/**
 * Check if a given object implements the UpdateTuitionDiscountRequest interface.
 */
export function instanceOfUpdateTuitionDiscountRequest(value: object): value is UpdateTuitionDiscountRequest {
    if (!('discountId' in value) || value['discountId'] === undefined) return false;
    if (!('calculationType' in value) || value['calculationType'] === undefined) return false;
    if (!('valueType' in value) || value['valueType'] === undefined) return false;
    if (!('scope' in value) || value['scope'] === undefined) return false;
    if (!('value' in value) || value['value'] === undefined) return false;
    if (!('min' in value) || value['min'] === undefined) return false;
    if (!('max' in value) || value['max'] === undefined) return false;
    if (!('description' in value) || value['description'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('priority' in value) || value['priority'] === undefined) return false;
    return true;
}

export function UpdateTuitionDiscountRequestFromJSON(json: any): UpdateTuitionDiscountRequest {
    return UpdateTuitionDiscountRequestFromJSONTyped(json, false);
}

export function UpdateTuitionDiscountRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateTuitionDiscountRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'discountId': json['discountId'],
        'calculationType': DiscountCalculationTypeFromJSON(json['calculationType']),
        'valueType': DiscountValueTypeFromJSON(json['valueType']),
        'scope': DiscountScopeFromJSON(json['scope']),
        'value': json['value'],
        'min': ApiUserTasksGetPageParameterFromJSON(json['min']),
        'max': ApiUserTasksGetPageParameterFromJSON(json['max']),
        'description': json['description'],
        'name': json['name'],
        'priority': ApiUserTasksGetPageParameterFromJSON(json['priority']),
    };
}

export function UpdateTuitionDiscountRequestToJSON(json: any): UpdateTuitionDiscountRequest {
    return UpdateTuitionDiscountRequestToJSONTyped(json, false);
}

export function UpdateTuitionDiscountRequestToJSONTyped(value?: UpdateTuitionDiscountRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'discountId': value['discountId'],
        'calculationType': DiscountCalculationTypeToJSON(value['calculationType']),
        'valueType': DiscountValueTypeToJSON(value['valueType']),
        'scope': DiscountScopeToJSON(value['scope']),
        'value': value['value'],
        'min': ApiUserTasksGetPageParameterToJSON(value['min']),
        'max': ApiUserTasksGetPageParameterToJSON(value['max']),
        'description': value['description'],
        'name': value['name'],
        'priority': ApiUserTasksGetPageParameterToJSON(value['priority']),
    };
}

